// itemsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchItems = createAsyncThunk(
  'items/fetchItems',
  async (indentID) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/viewTable/indentitems?indentId=${indentID}`
    );
    const data = await response.json();
    return data.filter(item => item.IndentID === indentID)
      .map(item => ({
        indentItemID: item.IndentItemID,
        itemName: item.ItemName,
        quantity: item.Quantity,
        stock: item.Stock || 0,
        itemID: item.ItemID,
        promisedDate: item.PromisedDate,
        normalDays: item.NormalDays,
        unitname: item.UnitName,
        difference: item.Difference,
        shRemarks: item.Remarks,
        quantityReceived: item.QuantityReceived
      }));
  }
);

export const fetchItemDescription = createAsyncThunk(
  'items/fetchDescription',
  async ({ itemId, indentID }) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/viewTable/itemdescription/${itemId}?indentId=${indentID}`
    );
    const data = await response.json();
    return { itemId, description: data.Description };
  }
);

const itemsSlice = createSlice({
  name: 'items',
  initialState: {
    items: [],
    descriptions: {},
    loadingDescriptions: {},
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItems.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchItems.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchItems.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchItemDescription.pending, (state, action) => {
        state.loadingDescriptions[action.meta.arg.itemId] = true;
      })
      .addCase(fetchItemDescription.fulfilled, (state, action) => {
        state.descriptions[action.payload.itemId] = action.payload.description;
        state.loadingDescriptions[action.payload.itemId] = false;
      })
      .addCase(fetchItemDescription.rejected, (state, action) => {
        state.loadingDescriptions[action.meta.arg.itemId] = false;
      });
  },
});

export default itemsSlice.reducer;